import { z } from "zod";
import { titleValidation } from "../../../utils/validation";
import { useForm, UseFormReturn } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { TopicCategoryFormData } from "../../topicCategory/entities/TopicCategory";
import { useEffect } from "react";
import { TranslationFunction } from "../../../utils/utils";

export const useTopicCategoryFormValidation = (
  data: TopicCategoryFormData | null,
  t: TranslationFunction
): UseFormReturn<TopicCategoryFormData> => {
  const schema = z.object({
    trainingId: z.union([z.string(), z.number()]),
    name: titleValidation(t),
  });

  const form = useForm<TopicCategoryFormData>({
    resolver: zodResolver(schema),
    defaultValues: data || {},
  });

  useEffect(() => {
    form.reset({ ...(data ?? {}) });
  }, [data, form]);

  return form;
};
